/* import __COLOCATED_TEMPLATE__ from './learn-button.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import templateOnlyComponent from '@ember/component/template-only';

const LearnButtonComponent = templateOnlyComponent();
export default LearnButtonComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Guidance::LearnButton': typeof LearnButtonComponent;
    'ai-agent/guidance/learn-button': typeof LearnButtonComponent;
  }
}
